import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop"]

  connect() {
    // Ensure we have the menu and backdrop elements
    // If not specifically targeted, find them by ID
    if (!this.hasMenuTarget) {
      this.menuTarget = document.getElementById("mobile-menu")
    }
    if (!this.hasBackdropTarget) {
      this.backdropTarget = document.getElementById("mobile-backdrop")
    }
  }

  toggle() {
    if (this.menuTarget.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("translate-x-full")
    this.backdropTarget.classList.remove("hidden")
    // Allow backdrop to fade in
    setTimeout(() => {
      this.backdropTarget.classList.add("bg-opacity-50")
      this.backdropTarget.classList.remove("bg-opacity-0")
    }, 10)
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.menuTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("bg-opacity-0")
    this.backdropTarget.classList.remove("bg-opacity-50")
    // Fade out backdrop before hiding
    setTimeout(() => {
      this.backdropTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 300)
  }
}
